import React from 'react';
import { Tag as _Tag } from 'src/components/Antd';
import css from './css.less';
const Tags = (props) => {
  const { data = [], onClose, disabled, ...rest } = props;
  return data.map((search, index) => (
    <Tag
      key={index}
      color='#eeeeee'
      closable
      visible
      disabled={disabled}
      onClose={(e) => onClose(e, index)}
      {...rest}>
      {search}{' '}
    </Tag>
  ));
};
export const Tag = (props) => {
  const { children, className, onClose, disabled, ...rest } = props;
  return (
    <_Tag
      className={`${css.searchList} ${className || ''}`}
      color='#eeeeee'
      closable
      visible
      onClose={onClose}
      disabled={disabled}
      {...rest}>
      {children}{' '}
    </_Tag>
  );
};
export default Tags;
